import React from 'react';
import {
  ABDL_SERVICES_PAGE_URL,
  ABOUT_PAGE_URL,
  CONTACT_PAGE_URL,
  DOMINATION_SERVICES_PAGE_URL,
  HOME_PAGE_URL,
} from '../../utils/Routes';
import { Link } from 'react-router-dom';

function CallToActionOne() {
  const buttons = [
    {
      text: 'Home',
      link: HOME_PAGE_URL,
      ariaLabel: `Go to homepage`,
    },
    {
      text: 'Contact',
      link: CONTACT_PAGE_URL,
      ariaLabel: `Contact Mistress Maria`,
    },
    {
      text: 'About',
      link: ABOUT_PAGE_URL,
      ariaLabel: `Learn more about Mistress Maria`,
    },
    {
      text: 'Domination',
      link: DOMINATION_SERVICES_PAGE_URL,
      ariaLabel: `View domination services`,
    },
    {
      text: 'ABDL',
      link: ABDL_SERVICES_PAGE_URL,
      ariaLabel: `View nursery and ABDL services`,
    },
  ];

  return (
    <section className='grid justify-center h-fit md:grid-flow-col mx-auto py-4 gap-x-6 gap-y-4 md:w-fit'>
      {buttons.map((btn, index) => (
        <Link
          key={index}
          to={btn.link}
          className='cursor-pointer hover:bg-colour6 hover:text-colour1 border-4 shadow-cardShadow border-solid border-colour6 bg-colour1 w-full text-center h-fit px-10 md:px-2 lg:px-12 py-2 mx-auto'
          aria-label={btn.ariaLabel}
          title={btn.text}
        >
          {btn.text}
        </Link>
      ))}
    </section>
  );
}

export default CallToActionOne;
